var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout"},[_vm._v(" Vous avez déconnecté ")])
}
var staticRenderFns = []

export { render, staticRenderFns }